// Brand-wide constants for Pikko Pet Care
export const PIKKO = {
  name: "Pikko Pet Care",
  tagline: "Compassionate Care, Happy Pets",
  subTagline: "We Care, They Deserve",
  positioning: "Veterinary & Pet Wellness Center",
  address:
    "Jl. Raya Jatimekar, RT.004/RW.012, Jatimekar, Kec. Jatiasih, Kota Bekasi, Jawa Barat 17422",
  addressShort: "Jatimekar, Jatiasih — Kota Bekasi",
  whatsappNumber: "0811 8283 030",
  whatsappIntl: "628118283030",
  whatsappLink:
    "https://wa.me/628118283030?text=" +
    encodeURIComponent(
      "Halo Pikko Pet Care, saya ingin booking konsultasi untuk hewan kesayangan saya."
    ),
  whatsappEmergency:
    "https://wa.me/628118283030?text=" +
    encodeURIComponent(
      "Halo Pikko Pet Care, saya butuh emergency care — mohon respon segera 🙏"
    ),
  instagram: "@pikkopetcare",
  instagramLink: "https://instagram.com/pikkopetcare",
  hours: "Setiap hari · 09.00 – 19.00 WIB",
  hoursShort: "09.00 – 19.00",
  hoursPraktek: "09.00 – 17.00 WIB",
  hoursGrooming: "09.00 – 16.00 WIB",
  hoursEmergency: "19.00 – 23.00 WIB",
  mapsLink: "https://maps.app.goo.gl/xbnCNzMZn5huayTV8",
  mapsEmbed:
    "https://www.google.com/maps?q=Pikko+Pet+Care+Jatimekar+Jatiasih+Bekasi&output=embed",
};

// Real doctors per latest brand posters
export const DOCTORS = [
  {
    img: "/images/team2.webp",
    pos: "center 18%",
    name: "drh. Shafira",
    role: "General Practitioner",
    desc: "Konsultasi & pemeriksaan hewan kesayangan",
    animals: ["Anjing", "Kucing"],
    schedule: "10 · 17 · 24 Mei",
    hours: "09.00 – 17.00 WIB",
  },
  {
    img: "/images/team3.webp",
    pos: "center 18%",
    name: "drh. Okara",
    role: "Dokter Praktik",
    desc: "Pemeriksaan rutin & perawatan harian",
    animals: ["Anjing", "Kucing"],
    schedule: "4 – 6 Mei",
    hours: "10.00 – 19.00 WIB",
  },
  {
    img: "/images/team1.webp",
    pos: "center 22%",
    name: "drh. Arga",
    role: "Exotic Veterinarian",
    desc: "Konsultasi & penanganan hewan exotic",
    animals: ["Rabbit", "Hamster", "Reptile", "Burung"],
    schedule: "13 · 18 · 23 · 28 Mei",
    hours: "09.00 – 17.00 WIB",
  },
];
